import axios from 'axios';
import applyInterceptors from './axiosInterceptors.js';

const instance = axios.create({
  // baseURL: 'http://10.250.34.247:8010'
  // baseURL: 'http://localhost:8000'
  // baseURL: 'https://esep.govtec.kz'
});

applyInterceptors(instance);


export default instance;
